import { FC } from 'react';
import ListIcon from '@material-ui/icons/List';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import {
  WbDivider,
  WbTabsList,
  WbTabsTrigger,
} from '@agilelab/plugin-wb-platform';
import { useTheme } from '@material-ui/core';

export const ScaffolderViewTypeButtons: FC = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        gap: theme.spacing(1),
        marginLeft: theme.spacing(1),
        alignItems: 'baseline',
        paddingTop: theme.spacing(0.3),
      }}
    >
      <WbDivider orientation="vertical" />
      <WbTabsList aria-label="Display mode">
        <WbTabsTrigger
          value="grid"
          icon={<ViewModuleIcon style={{ fontSize: 16 }} />}
          aria-label="Grid"
        />
        <WbTabsTrigger
          value="table"
          icon={<ListIcon style={{ fontSize: 16 }} />}
          aria-label="Table"
        />
      </WbTabsList>
    </div>
  );
};
